import Vue from 'vue'
import VueResource from 'vue-resource'
import toastr from '../toastr'
import Moment from 'moment'

if ($('#route_grid_header').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#route_grid_header',
    methods: {
      assignRoutesToBags: function() {
        const data = {
          fromDate: (new Moment()).add(1, 'days').format('YYYY-MM-DD'),
        }
        this.sendRequestForAssignRoutesToBags(data)
      },
      assignRoutesToBagsForTwoDays: function() {
        const data = {
          fromDate: (new Moment()).add(1, 'days').format('YYYY-MM-DD'),
          toDate: (new Moment()).add(2, 'days').format('YYYY-MM-DD')
        }
        this.sendRequestForAssignRoutesToBags(data)
      },
      sendRequestForAssignRoutesToBags(data) {
        let url = Routing.generate('api_post_worker', { task: 'UpdateRoutesOnBag' })

        this.$http.post(url, data)
          .then(() => {
            toastr.success(Translator.trans('worker_task.success_created'))
            $('#auto_assign').button('reset')
          }, () => {
            toastr.error(Translator.trans('route.flashes.assigned_error'))
            $('#auto_assign').button('reset')
          })
      }
    }
  })
}
